import { createBrowserRouter } from 'react-router-dom';

export const getRouter = async () => {
  const { getAppRoutes } = await import('@cp/core/routing/routes');
  const routes = getAppRoutes();

  return createBrowserRouter(routes);
};
